module.exports = __webpack_public_path__ + "static/img/celoscope-detail-29.583616b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-29.jpg
// module id = PZud
// module chunks = 51